// import packageListBl from '@/bianla/package-list-bl'
// import packageDetailBl from '@/bianla/package-detail-bl'
import {
  getUrlSpecifiedParam,
  setCookie,
  wechatShare,
  getLinktoAuthUrl
} from "@/assets/js/util";
import { authNeed, seoVisitLog } from "@/assets/js/api";
import skinning from "@/assets/js/skinning";
import { authNeedPages } from "@/config/auth";

import { Dialog } from "vant";

import Vue from "vue";

import Router from "vue-router";
import { resolve } from "core-js/fn/promise";
import { Store } from "vuex";
import store from "@/store";

Vue.use(Router);
const Index = resolve => {
  import(/* webpackChunkName: "Index" */ "@/pages/Index").then(module => {
    resolve(module);
  });
};

const DoctorCardGive = resolve => {
  import(/* webpackChunkName: "DoctorCardGive" */
  "@/pages/doctorCard/give").then(module => {
    resolve(module);
  });
};

const DoctorCardReceive = resolve => {
  import(/* webpackChunkName: "DoctorCardReceive" */
  "@/pages/doctorCard/receive").then(module => {
    resolve(module);
  });
};

const DoctorBuyHistory = resolve => {
  import(/* webpackChunkName: "DoctorHistory" */
  "@/pages/doctorCard/history").then(module => {
    resolve(module);
  });
};

const DoctorCardHome = resolve => {
  import(/* webpackChunkName: "DoctorCardHome" */
  "@/pages/doctorCard/home").then(module => {
    resolve(module);
  });
};

const DoctorCardOrderDetail = resolve => {
  import(/* webpackChunkName: "DoctorCardOrderDetail" */
  "@/pages/doctorCard/orderDetail").then(module => {
    resolve(module);
  });
};

const DoctorCardLogistics = resolve => {
  import(/* webpackChunkName: "DoctorCardLogistics" */
  "@/pages/doctorCard/logistics").then(module => {
    resolve(module);
  });
};

const healthServiceIndex = resolve => {
  import(/* webpackChunkName: "healthServiceIndex" */
  "@/pages/healthService/index").then(module => {
    resolve(module);
  });
};
const healthServicePackage = resolve => {
  import(/* webpackChunkName: "healthServicePackage" */
  "@/pages/healthService/package").then(module => {
    resolve(module);
  });
};

const healthServiceApply = resolve => {
  import(/* webpackChunkName: "healthServiceApply" */
  "@/pages/healthService/apply").then(module => {
    resolve(module);
  });
};

const healthServiceOrderlist = resolve => {
  import(/* webpackChunkName: "healthServiceOrderlist" */
  "@/pages/healthService/orderList").then(module => {
    resolve(module);
  });
};

const healthServiceOrderdetail = resolve => {
  import(/* webpackChunkName: "healthServiceOrderdetail" */
  "@/pages/healthService/orderDetail").then(module => {
    resolve(module);
  });
};

const healthServiceHome = resolve => {
  import(/* webpackChunkName: "healthServiceHome" */
  "@/pages/healthService/home").then(module => {
    resolve(module);
  });
};
const healthServiceCmbagree = resolve => {
  import(/* webpackChunkName: "healthServiceCmbagree" */
  "@/pages/healthService/cmbAgree").then(module => {
    resolve(module);
  });
};
const healthServiceDsagree = resolve => {
  import(/* webpackChunkName: "healthServiceDsagree" */
  "@/pages/healthService/dsAgree").then(module => {
    resolve(module);
  });
};

const healthServiceDspolicy = resolve => {
  import(/* webpackChunkName: "healthServiceDspolicy" */
  "@/pages/healthService/dsPolicy").then(module => {
    resolve(module);
  });
};

const DoctorCardList = resolve => {
  import(/* webpackChunkName: "DoctorCardList" */
  "@/pages/doctorCard/list").then(module => {
    resolve(module);
  });
};

const DoctorCardApply = resolve => {
  import(/* webpackChunkName: "DoctorCardApply" */
  "@/pages/doctorCard/apply").then(module => {
    resolve(module);
  });
};

const DoctorCardExchange = resolve => {
  import(/* webpackChunkName: "DoctorCardExchange" */
  "@/pages/doctorCard/exchange").then(module => {
    resolve(module);
  });
};

const DoctorCardPackage = resolve => {
  import(/* webpackChunkName: "DoctorCardPackage" */
  "@/pages/doctorCard/package").then(module => {
    resolve(module);
  });
};

const DoctorCardRepurchase = resolve => {
  import(/* webpackChunkName: "DoctorCardPackage" */
  "@/pages/doctorCard/repurchase").then(module => {
    resolve(module);
  });
};

const LoadingV1 = resolve => {
  import(/* webpackChunkName: "LoadingV1" */
  "@/components/common/LoadingV1").then(module => {
    resolve(module);
  });
};
const InsuranceExplain = resolve => {
  import(/* webpackChunkName: "InsuranceExplain" */
  "@/pages/insurance/Explain").then(module => {
    resolve(module);
  });
};
const HealthInsurance = resolve => {
  import(/* webpackChunkName: "HealthInsurance" */
  "@/pages/insurance/HealthInsurance").then(module => {
    resolve(module);
  });
};
const HistoryPackage = resolve => {
  import(/* webpackChunkName: "HistoryPackage" */
  "@/pages/history/Package").then(module => {
    resolve(module);
  });
};
const packageListV2 = resolve => {
  import(/* webpackChunkName: "packageListV2" */
  "@/pages/package/packageListV2").then(module => {
    resolve(module);
  });
};

// orgListV2.vue
const orgListV2 = resolve => {
  import(/* webpackChunkName: "orgListV2" */ "@/pages/org/orgListV2").then(
    module => {
      resolve(module);
    }
  );
};

const search = resolve => {
  import(/* webpackChunkName: "search" */ "@/pages/search/search").then(
    module => {
      resolve(module);
    }
  );
};
const success = resolve => {
  import(/* webpackChunkName: "success" */ "@/pages/dmi/success").then(
    module => {
      resolve(module);
    }
  );
};
const index = resolve => {
  import(/* webpackChunkName: "index" */ "@/pages/dmi/index").then(module => {
    resolve(module);
  });
};
const fail = resolve => {
  import(/* webpackChunkName: "fail" */ "@/pages/dmi/fail").then(module => {
    resolve(module);
  });
};
const mydmi = resolve => {
  import(/* webpackChunkName: "mydmi" */ "@/pages/dmi/mydmi").then(module => {
    resolve(module);
  });
};
const cityList = resolve => {
  import(/* webpackChunkName: "cityList" */ "@/pages/city/city-list").then(
    module => {
      resolve(module);
    }
  );
};
const error = resolve => {
  import(/* webpackChunkName: "error" */ "@/components/error").then(module => {
    resolve(module);
  });
};
const evaluate = resolve => {
  import(/* webpackChunkName: "evaluate" */ "@/pages/order/evaluate").then(
    module => {
      resolve(module);
    }
  );
};
const familyList = resolve => {
  import(/* webpackChunkName: "family" */ "@/pages/family/family-list").then(
    module => {
      resolve(module);
    }
  );
};
const addFamily = resolve => {
  import(/* webpackChunkName: "addFamily" */ "@/pages/family/add-family").then(
    module => {
      resolve(module);
    }
  );
};
const addYuYue = resolve => {
  import(/* webpackChunkName: "addYuYue" */ "@/pages/order/AddYuYue").then(
    module => {
      resolve(module);
    }
  );
};

const Assets = resolve => {
  import(/* webpackChunkName: "Assets" */ "@/pages/assets/Assets").then(
    module => {
      resolve(module);
    }
  );
};
const Coupon = resolve => {
  import(/* webpackChunkName: "Coupon" */ "@/pages/assets/Coupon").then(
    module => {
      resolve(module);
    }
  );
};
const CardTransactionDetail = resolve => {
  import(/* webpackChunkName: "prepaid-card-detail" */
  "@/pages/assets/card-transaction-detail").then(module => {
    resolve(module);
  });
};
const PrepaidCardDetail = resolve => {
  import(/* webpackChunkName: "prepaid-card-detail" */
  "@/pages/assets/prepaid-card-detail").then(module => {
    resolve(module);
  });
};
const MedicalCard = resolve => {
  import(/* webpackChunkName: "MedicalCard" */
  "@/pages/assets/MedicalCard").then(module => {
    resolve(module);
  });
};
// MedicalCardOrg.vue
const MedicalCardOrg = resolve => {
  import(/* webpackChunkName: "MedicalCardOrg" */
  "@/pages/exchangeCard/MedicalcardOrg").then(module => {
    resolve(module);
  });
};

const orgHome = resolve => {
  import(/* webpackChunkName: "orgHome" */ "@/pages/org/Home").then(module => {
    resolve(module);
  });
};
const packageOrg = resolve => {
  import(/* webpackChunkName: "packageOrg" */
  "@/pages/package/package-org").then(module => {
    resolve(module);
  });
};
const multiPackageList = resolve => {
  import(/* webpackChunkName: "multiPackageList" */
  "@/pages/package/multi-ackage-list").then(module => {
    resolve(module);
  });
};
const packageOrgV2 = resolve => {
  import(/* webpackChunkName: "packageOrgV2" */
  "@/pages/package/packageOrgV2").then(module => {
    resolve(module);
  });
};
const packageDetail = resolve => {
  import(/* webpackChunkName: "packageDetail" */
  "@/pages/medicalCard/package-detail").then(module => {
    resolve(module);
  });
};
const packageDetailV2 = resolve => {
  import(/* webpackChunkName: "packageDetailV2" */ "@/pages/package/Home").then(
    module => {
      resolve(module);
    }
  );
};
const UserCenter = resolve => {
  import(/* webpackChunkName: "UserCenter" */
  "@/pages/userCenter/Home").then(module => {
    resolve(module);
  });
};
const Mypoint = resolve => {
  import(/* webpackChunkName: "mypoint" */
  "@/pages/userCenter/mypoint").then(module => {
    resolve(module);
  });
};
const FeedbackHelp = resolve => {
  import(/* webpackChunkName: "FeedbackHelp" */
  "@/pages/feedbackHelp/Home").then(module => {
    resolve(module);
  });
};
const Feedback = resolve => {
  import(/* webpackChunkName: "Feedback" */
  "@/pages/feedbackHelp/Feedback").then(module => {
    resolve(module);
  });
};
const FeedbackResult = resolve => {
  import(/* webpackChunkName: "FeedbackResult" */
  "@/pages/feedbackHelp/FeedbackResult").then(module => {
    resolve(module);
  });
};
const Assistant = resolve => {
  import(/* webpackChunkName: "Assistant" */
  "@/pages/feedbackHelp/Assistant").then(module => {
    resolve(module);
  });
};
const problem = resolve => {
  import(/* webpackChunkName: "problem" */ "@/pages/feedbackHelp/Problem").then(
    module => {
      resolve(module);
    }
  );
};
const report = resolve => {
  import(/* webpackChunkName: "report" */ "@/pages/report/index").then(
    module => {
      resolve(module);
    }
  );
};
const reportList = resolve => {
  import(/* webpackChunkName: "report" */ "@/pages/report/reportList").then(
    module => {
      resolve(module);
    }
  );
};
const uploadReport = resolve => {
  import(/* webpackChunkName: "report" */ "@/pages/report/uploadReport").then(
    module => {
      resolve(module);
    }
  );
};
const reportDetail = resolve => {
  import(/* webpackChunkName: "report" */ "@/pages/report/detail").then(
    module => {
      resolve(module);
    }
  );
};
const reportPreview = resolve => {
  import(/* webpackChunkName: "report" */ "@/pages/report/previewImg").then(
    module => {
      resolve(module);
    }
  );
};
// const viewurl = resolve => {
//   import(/* webpackChunkName: "viewurl" */
//   '@/pages/viewurl').then(module => {
//     resolve(module)
//   })
// }
// const orders = resolve => {
//   import(/* webpackChunkName: "orders" */
//   '@/pages/orders').then(module => {
//     resolve(module)
//   })
// }
const OrderList = resolve => {
  import(/* webpackChunkName: "OrderList" */ "@/pages/order/OrderList").then(
    module => {
      resolve(module);
    }
  );
};
const OrderDetail = resolve => {
  import(/* webpackChunkName: "OrderDetail" */
  "@/pages/order/OrderDetail").then(module => {
    resolve(module);
  });
};

const cardOrderDetail = resolve => {
  import(/* webpackChunkName: "cardOrderDetail" */
  "@/pages/order/CardOrderDetail").then(module => {
    resolve(module);
  });
};
// const invoiceAdd = resolve => {
//   import(/* webpackChunkName: "invoiceAdd" */
//   '@/pages/invoice-add').then(module => {
//     resolve(module)
//   })
// }

const register = resolve => {
  import(/* webpackChunkName: "register" */

  "@/pages/register/register").then(module => {
    resolve(module);
  });
};
const registerSuc = resolve => {
  import(/* webpackChunkName: "registerSuc" */
  "@/pages/register/registerSuc").then(module => {
    resolve(module);
  });
};
const provision = resolve => {
  import(/* webpackChunkName: "provision" */
  "@/pages/provision/provision").then(module => {
    resolve(module);
  });
};
const provisionAgree = resolve => {
  import(/* webpackChunkName: "provisionAgree" */
  "@/pages/provision/agree").then(module => {
    resolve(module);
  });
};
const provisionPrivacy = resolve => {
  import(/* webpackChunkName: "provisionPrivacy" */
  "@/pages/provision/privacy").then(module => {
    resolve(module);
  });
};
const payAfter = resolve => {
  import(/* webpackChunkName: "payAfter" */ "@/pages/payAfter/pay-after").then(
    module => {
      resolve(module);
    }
  );
};
const bookSuc = resolve => {
  import(/* webpackChunkName: "bookSuc" */ "@/pages/medicalCard/book-suc").then(
    module => {
      resolve(module);
    }
  );
};
const orderCard = resolve => {
  import(/* webpackChunkName: "orderCard" */
  "@/pages/medicalCard/order-card").then(module => {
    resolve(module);
  });
};
const apply = resolve => {
  import(/* webpackChunkName: "apply" */ "@/pages/apply/apply").then(module => {
    resolve(module);
  });
};
const applyBefore = resolve => {
  import(/* webpackChunkName: "applyBefore" */
  "@/pages/apply/apply-before").then(module => {
    resolve(module);
  });
};
const medicalcardApply = resolve => {
  import(/* webpackChunkName: "medicalcardApply" */
  "@/pages/apply/medicalcard-apply").then(module => {
    resolve(module);
  });
};
const agreement = resolve => {
  import(/* webpackChunkName: "agreement" */ "@/pages/apply/agreement").then(
    module => {
      resolve(module);
    }
  );
};
const applyAddItem = resolve => {
  import(/* webpackChunkName: "applyAddItem" */
  "@/pages/apply/apply-addItem").then(module => {
    resolve(module);
  });
};
const orgDetailBl = resolve => {
  import(/* webpackChunkName: "orgDetailBl" */
  "@/pages/medicalCard/org-detail-bl").then(module => {
    resolve(module);
  });
};

const loginCard = resolve => {
  import(/* webpackChunkName: "loginCard" */
  "@/pages/medicalCard/login-card").then(module => {
    resolve(module);
  });
};
const exchangeResult = resolve => {
  import(/* webpackChunkName: "exchangeResult" */
  "@/pages/medicalCard/exchange-result").then(module => {
    resolve(module);
  });
};
const cardMall = resolve => {
  import(/* webpackChunkName: "cardMall" */
  "@/pages/medicalCard/card-mall").then(module => {
    resolve(module);
  });
};
const medicalcardList = resolve => {
  import(/* webpackChunkName: "medicalcardList" */
  "@/pages/medicalCard/medicalcard-list").then(module => {
    resolve(module);
  });
};
const medicalCardDetail = resolve => {
  import(/* webpackChunkName: "medicalCardDetail" */
  "@/pages/medicalCard/Home").then(module => {
    resolve(module);
  });
};
const medicalCardGive = resolve => {
  import(/* webpackChunkName: "medicalCardGive" */
  "@/pages/medicalCard/Give").then(module => {
    resolve(module);
  });
};

const refund = resolve => {
  import(/* webpackChunkName: "refund" */ "@/pages/refund/refund.vue").then(
    module => {
      resolve(module);
    }
  );
};

const refundDetail = resolve => {
  import(/* webpackChunkName: "refundDetail" */
  "@/pages/refund/refund-detail.vue").then(module => {
    resolve(module);
  });
};

const refundExplain = resolve => {
  import(/* webpackChunkName: "refundExplain" */
  "@/pages/refund/refund-explain.vue").then(module => {
    resolve(module);
  });
};
// 支付成功
const paySuccess = resolve => {
  import(/* webpackChunkName: "paySuccess" */
  "@/pages/payAfter/pay-success.vue").then(module => {
    resolve(module);
  });
};
// 支付失败
const payFail = resolve => {
  import(/* webpackChunkName: "payFail" */
  "@/pages/payAfter/pay-fail.vue").then(module => {
    resolve(module);
  });
};
// 水滴筹
const ShuiDiChou = resolve => {
  import(/* webpackChunkName: "ShuiDiChou" */
  "@/pages/activity/shuidichou/App.vue").then(module => {
    resolve(module);
  });
};
// 通用活动模板
const CommonActivity = resolve => {
  import(/* webpackChunkName: "CommonActivity" */
  "@/pages/activity/CommonActivity/CommonActivity.vue").then(module => {
    resolve(module);
  });
};
// 施予受
const ShiYuShou = resolve => {
  import(/* webpackChunkName: "ShiYuShou" */ "@/pages/shiyushou/Home.vue").then(
    module => {
      resolve(module);
    }
  );
};
// 施予受推广页
const ShiYuShouExtension = resolve => {
  import(/* webpackChunkName: "ShiYuShouExtension" */
  "@/pages/shiyushou/Extension.vue").then(module => {
    resolve(module);
  });
};
// 8月秒杀活动
const SeckillApp = resolve => {
  import(/* webpackChunkName: "SeckillApp" */
  "@/pages/activity/seckill/App.vue").then(module => {
    resolve(module);
  });
};
// 8月秒杀活动-抢购页面
const SeckillRushToBuy = resolve => {
  import(/* webpackChunkName: "SeckillRushToBuy" */
  "@/pages/activity/seckill/RushToBuy.vue").then(module => {
    resolve(module);
  });
};
// 8月秒杀活动-秒杀产品列表
const SeckillList = resolve => {
  import(/* webpackChunkName: "SeckillList" */
  "@/pages/activity/seckill/SeckillList.vue").then(module => {
    resolve(module);
  });
};
// 8月秒杀活动-秒杀结果
const SeckillResult = resolve => {
  import(/* webpackChunkName: "SeckillResult" */
  "@/pages/activity/seckill/Result.vue").then(module => {
    resolve(module);
  });
};
// 大礼包880
const Giftbag880 = resolve => {
  import(/* webpackChunkName: "Giftbag880" */
  "@/pages/activity/Giftbag/Giftbag880").then(module => {
    resolve(module);
  });
};
// 荔湾医院活动页面
const liwan = resolve => {
  import(/* webpackChunkName: "liwan" */ "@/pages/activity/liwan/App.vue").then(
    module => {
      resolve(module);
    }
  );
};

// 建行领券活动页面
const ccb = resolve => {
  import(/* webpackChunkName: "ccb" */ "@/pages/activity/ccb/index.vue").then(
    module => {
      resolve(module);
    }
  );
};

// 联通页面
const liantong = resolve => {
  import(/* webpackChunkName: "liantong" */
  "@/pages/activity/liantong/index.vue").then(module => {
    resolve(module);
  });
};

// 中秋领劵活动页面
const coupon1 = resolve => {
  import(/* webpackChunkName: "coupon1" */
  "@/pages/activity/coupon1/App.vue").then(module => {
    resolve(module);
  });
};
// 中秋国庆双节领劵活动页面
const coupon2 = resolve => {
  import(/* webpackChunkName: "coupon2" */
  "@/pages/activity/coupon2/App.vue").then(module => {
    resolve(module);
  });
};
// 重阳节
const double9 = resolve => {
  import(/* webpackChunkName: "double9" */
  "@/pages/activity/doubleNinth/double9.vue").then(module => {
    resolve(module);
  });
};
// 双11
const doubleEleven = resolve => {
  import(/* webpackChunkName: "doubleEleven" */
  "@/pages/activity/doubleEleventh/App.vue").then(module => {
    resolve(module);
  });
};
// 七夕
const doubleSeventh2019 = resolve => {
  import(/* webpackChunkName: "doubleSeventh2019" */
  "@/pages/activity/doubleSeventh/DoubleSeventh2019.vue").then(module => {
    resolve(module);
  });
};
// 建行折扣活动
const ccbDiscount = resolve => {
  import(/* webpackChunkName: "ccbDiscount" */
  "@/pages/activity/ccbDiscount/ccbDiscount.vue").then(module => {
    resolve(module);
  });
};

// 全棉时代活动
const purcotton = resolve => {
  import(/* webpackChunkName: "purcotton" */
  "@/pages/activity/purcotton/index.vue").then(module => {
    resolve(module);
  });
};

// 问卷调查
const Questionnaire = resolve => {
  import(/* webpackChunkName: "Questionnaire" */
  "@/pages/questionnaire/App").then(module => {
    resolve(module);
  });
};
// 问卷调查-首页
const QuestionnaireHome = resolve => {
  import(/* webpackChunkName: "QuestionnaireHome" */
  "@/pages/questionnaire/Home").then(module => {
    resolve(module);
  });
};
// 问卷调查-答题
const Answer = resolve => {
  import(/* webpackChunkName: "Answer" */ "@/pages/questionnaire/Answer").then(
    module => {
      resolve(module);
    }
  );
};
// 问卷调查-结果
const Result = resolve => {
  import(/* webpackChunkName: "Result" */ "@/pages/questionnaire/Result").then(
    module => {
      resolve(module);
    }
  );
};
// 问卷调查-问题1
const Problem1 = resolve => {
  import(/* webpackChunkName: "Problem1" */
  "@/pages/questionnaire/Problem1").then(module => {
    resolve(module);
  });
};
// 问卷调查-问题2
const Problem2 = resolve => {
  import(/* webpackChunkName: "Problem2" */
  "@/pages/questionnaire/Problem2").then(module => {
    resolve(module);
  });
};
// 问卷调查-问题3
const Problem3 = resolve => {
  import(/* webpackChunkName: "Problem3" */
  "@/pages/questionnaire/Problem3").then(module => {
    resolve(module);
  });
};
// 问卷调查-问题4
const Problem4 = resolve => {
  import(/* webpackChunkName: "Problem4" */
  "@/pages/questionnaire/Problem4").then(module => {
    resolve(module);
  });
};
// 问卷调查-问题5
const Problem5 = resolve => {
  import(/* webpackChunkName: "Problem5" */
  "@/pages/questionnaire/Problem5").then(module => {
    resolve(module);
  });
};
// 问卷调查-问题6
const Problem6 = resolve => {
  import(/* webpackChunkName: "Problem6" */
  "@/pages/questionnaire/Problem6").then(module => {
    resolve(module);
  });
};
// 问卷调查-问题7
const Problem7 = resolve => {
  import(/* webpackChunkName: "Problem7" */
  "@/pages/questionnaire/Problem7").then(module => {
    resolve(module);
  });
};
// 问卷调查-问题8
const Problem8 = resolve => {
  import(/* webpackChunkName: "Problem8" */
  "@/pages/questionnaire/Problem8").then(module => {
    resolve(module);
  });
};
// 问卷调查-问题9
const Problem9 = resolve => {
  import(/* webpackChunkName: "Problem9" */
  "@/pages/questionnaire/Problem9").then(module => {
    resolve(module);
  });
};
// 套餐加项
const addition = resolve => {
  import(/* webpackChunkName: "addition" */ "@/pages/apply/addition").then(
    module => {
      resolve(module);
    }
  );
};

// 支付详情
const payDetails = resolve => {
  import(/* webpackChunkName: "payDetails" */
  "@/pages/payAfter/pay-details").then(module => {
    resolve(module);
  });
};
// 我的保单
const myPolicy = resolve => {
  import(/* webpackChunkName: "myPolicy" */ "@/pages/policy/my-policy").then(
    module => {
      resolve(module);
    }
  );
};
// 历史保单
const historyPolicy = resolve => {
  import(/* webpackChunkName: "historyPolicy" */
  "@/pages/policy/history-policy").then(module => {
    resolve(module);
  });
};

// 保单详情
const policyDetail = resolve => {
  import(/* webpackChunkName: "policyDetail" */
  "@/pages/policy/policy-detail").then(module => {
    resolve(module);
  });
};

// 删除
// const refundD = resolve => {
//   import(/* webpackChunkName: "refundD" */
//   '@/pages/refund').then(module => {
//     resolve(module)
//   })
// }
// 收藏
const Collection = resolve => {
  import(/* webpackChunkName: "Collection" */
  "@/pages/collection/Collection").then(module => {
    resolve(module);
  });
};
// 机构收藏页
const CollectionOrg = resolve => {
  import(/* webpackChunkName: "CollectionOrg" */ "@/pages/collection/Org").then(
    module => {
      resolve(module);
    }
  );
};
// 套餐收藏页
const CollectionPackage = resolve => {
  import(/* webpackChunkName: "CollectionPackage" */
  "@/pages/collection/Package").then(module => {
    resolve(module);
  });
};
// 套餐收藏页
const CollectionArticle = resolve => {
  import(/* webpackChunkName: "CollectionArticle" */
  "@/pages/collection/Article").then(module => {
    resolve(module);
  });
};
// 套餐对比页
const Comparison = resolve => {
  import(/* webpackChunkName: "Comparison" */
  "@/pages/comparison/Comparison").then(module => {
    resolve(module);
  });
};
// 套餐对比页
const ComparisonSelect = resolve => {
  import(/* webpackChunkName: "ComparisonSelect" */
  "@/pages/comparison/ComparisonSelect").then(module => {
    resolve(module);
  });
};
// 文章详情页
const NewsDetail = resolve => {
  import(/* webpackChunkName: "NewsDetail" */ "@/pages/news/NewsDetail").then(
    module => {
      resolve(module);
    }
  );
};
// 文章列表页
const NewsList = resolve => {
  import(/* webpackChunkName: "NewsList" */ "@/pages/news/NewsList").then(
    module => {
      resolve(module);
    }
  );
};
// 文章列表1
const NewsList1 = resolve => {
  import(/* webpackChunkName: "NewsList1" */ "@/pages/news/List1").then(
    module => {
      resolve(module);
    }
  );
};
// 文章列表2
const NewsList2 = resolve => {
  import(/* webpackChunkName: "NewsList2" */ "@/pages/news/List2").then(
    module => {
      resolve(module);
    }
  );
};
// 文章列表3
const NewsList3 = resolve => {
  import(/* webpackChunkName: "NewsList3" */ "@/pages/news/List3").then(
    module => {
      resolve(module);
    }
  );
};
// 文章列表4
const NewsList4 = resolve => {
  import(/* webpackChunkName: "NewsList4" */ "@/pages/news/List4").then(
    module => {
      resolve(module);
    }
  );
};
// 文章列表5
const NewsList5 = resolve => {
  import(/* webpackChunkName: "NewsList5" */ "@/pages/news/List5").then(
    module => {
      resolve(module);
    }
  );
};
// 文章列表6
const NewsList6 = resolve => {
  import(/* webpackChunkName: "NewsList5" */ "@/pages/news/List6").then(
    module => {
      resolve(module);
    }
  );
};
const AfterSale = resolve => {
  import(/* webpackChunkName: "AfterSale" */ "@/pages/afterSale/home").then(
    module => {
      resolve(module);
    }
  );
};
// 优享活动
const ExcellentEnjoyment = resolve => {
  import(/* webpackChunkName: "ExcellentEnjoyment" */
  "@/pages/activity/excellentEnjoyment/home").then(module => {
    resolve(module);
  });
};
// 优享活动
const JoininSuc = resolve => {
  import(/* webpackChunkName: "JoininSuc" */
  "@/pages/activity/excellentEnjoyment/joininSuc").then(module => {
    resolve(module);
  });
};
// 入职体检活动
const EntryWelfare = resolve => {
  import(/* webpackChunkName: "EntryWelfare" */
  "@/pages/activity/EntryWelfare/EntryWelfare").then(module => {
    resolve(module);
  });
};
// 第三方定制首页 泰福利
const TaiWelfare = resolve => {
  import(/* webpackChunkName: "TaiWelfare" */
  "@/pages/ThirdPartyIndex/TaiWelfare").then(module => {
    resolve(module);
  });
};
const ThirdPartyIndex = resolve => {
  import(/* webpackChunkName: "ThirdPartyIndex" */
  "@/pages/ThirdPartyIndex/Home").then(module => {
    resolve(module);
  });
};
// 第三方定制首页 演示
const ThirdPartyIndexDemo = resolve => {
  import(/* webpackChunkName: "TaiWelfare" */
  "@/pages/ThirdPartyIndex/Demo").then(module => {
    resolve(module);
  });
};
const Reload = resolve => {
  import(/* webpackChunkName: "ReloadPage" */ "@/pages/reload/reload").then(
    module => {
      resolve(module);
    }
  );
};

// 南医大
const Nanyida = resolve => {
  import("@/pages/company/nanyida/home").then(module => {
    resolve(module);
  });
};
// 合作首页
const Cooperation = resolve => {
  import("@/pages/cooperation/Home").then(module => {
    resolve(module);
  });
};
//  体软咨询
const SoftwareConsulting = resolve => {
  import("@/pages/cooperation/SoftwareConsulting").then(module => {
    resolve(module);
  });
};
// 商务合作
const BusinessCooperation = resolve => {
  import("@/pages/cooperation/BusinessCooperation").then(module => {
    resolve(module);
  });
};
// 企业需求
const BusinessNeeds = resolve => {
  import("@/pages/cooperation/BusinessNeeds").then(module => {
    resolve(module);
  });
};
// 新版企业复工需求
const NewBusinessNeeds = resolve => {
  import("@/pages/cooperation/NewBusinessNeeds").then(module => {
    resolve(module);
  });
};
// 招商加盟
const AgentJoining = resolve => {
  import("@/pages/cooperation/AgentJoining").then(module => {
    resolve(module);
  });
};
// 提交成功
const SubmitSuccess = resolve => {
  import("@/pages/cooperation/SubmitSuccess").then(module => {
    resolve(module);
  });
};
// 体检指引
const ReservationIndex = resolve => {
  import("@/pages/reservation/Reservation").then(module => resolve(module));
};

// 陈超
const doctorCard2 = resolve => {
  import(/* webpackChunkName: "doctorCard2" */
  "@/pages/doctorCard2/index").then(module => {
    resolve(module);
  });
};

const doctorCardCenter = resolve => {
  import(/* webpackChunkName: "doctorCard2" */
  "@/pages/doctorCard2/center").then(module => {
    resolve(module);
  });
};

const doctorCardCoupon = resolve => {
  import(/* webpackChunkName: "doctorCard2" */
  "@/pages/doctorCard2/Coupon").then(module => {
    resolve(module);
  });
};

const doctorCardPackage2 = resolve => {
  import(/* webpackChunkName: "doctorCard2" */
  "@/pages/doctorCard2/package").then(module => {
    resolve(module);
  });
};

const doctorCardPackageDetail = resolve => {
  import(/* webpackChunkName: "doctorCard2" */
  "@/pages/doctorCard2/package-detail").then(module => {
    resolve(module);
  });
};

// 健康保险
const insuranceTest = resolve => {
  import(/* webpackChunkName: "insuranceTest" */
  "@/pages/insuranceTest/index").then(module => {
    resolve(module);
  });
};
// 拼团
const groupBuyDetail = resolve => {
  import(/* webpackChunkName: "groupBuyDetail" */
  "@/pages/groupBuy/detail").then(module => {
    resolve(module);
  });
};
//我的账户
const myAccount = resolve => {
  import(/* webpackChunkName: "groupBuyDetail" */
  "@/pages/dmi/my-account").then(module => {
    resolve(module);
  });
};
//z账户明细
const accountDetail = resolve => {
  import(/* webpackChunkName: "groupBuyDetail" */
  "@/pages/dmi/account-detail").then(module => {
    resolve(module);
  });
};

//机构套餐列表
const packageOrgList = resolve => {
  import(/* webpackChunkName: "groupBuyDetail" */
  "@/pages/packageOrg/list").then(module => {
    resolve(module);
  });
};
//专科体检
const packageOrgListSpecialty = resolve => {
  import(/* webpackChunkName: "groupBuyDetail" */
  "@/pages/packageOrg/specialty").then(module => {
    resolve(module);
  });
};
//58同城套餐
const package58List = resolve => {
  import(/* webpackChunkName: "package58List" */
  "@/pages/package/58-package-list").then(module => {
    resolve(module);
  });
};
// 设置
const setUp = resolve => {
  import(/* webpackChunkName: "groupBuyDetail" */ "@/pages/setUp/home").then(
    module => {
      resolve(module);
    }
  );
};

const setUpAgreement = resolve => {
  import(/* webpackChunkName: "groupBuyDetail" */
  "@/pages/setUp/agreement").then(module => {
    resolve(module);
  });
};

const pocketInduction = resolve => {
  import(/* webpackChunkName: "pocketInduction" */
  "@/pages/package/pocket-induction").then(module => {
    resolve(module);
  });
};
const pocketSpecialPhysicalExamination = resolve => {
  import(/* webpackChunkName: "pocketSpecialPhysicalExamination" */
  "@/pages/package/pocket-special-physical-examination").then(module => {
    resolve(module);
  });
};

const ConsumptionRegulation = resolve => {
  import(/* webpackChunkName: "ConsumptionRegulation" */
  "@/pages/assets/consumption-regulation").then(module => {
    resolve(module);
  });
};

const PurchaseAgreement = resolve => {
  import(/* webpackChunkName: "PurchaseAgreement" */
  "@/pages/assets/purchase-agreement").then(module => {
    resolve(module);
  });
};

// 支付成功
const payCardSuccess = resolve => {
  import(/* webpackChunkName: "pay-card-success" */
  "@/pages/payAfter/pay-card-success.vue").then(module => {
    resolve(module);
  });
};

const router = new Router({
  routes: [
    {
      path: "/history-package",
      component: HistoryPackage,
      name: "HistoryPackage",
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "浏览历史",
          menu: true
        },
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: "*",
      redirect: "/"
    },
    // {
    //   path: '/refundD',
    //   name: 'refundD',
    //   meta: {
    //     title: brandConfig.companyName,
    //     titleBar: {
    //       show: true,
    //       title: brandConfig.companyName,
    //       menu: true
    //     },
    //     index: 0,
    //     keepAlive: true
    //   },
    //   component: refundD
    // },
    {
      path: "/",
      name: "index",
      meta: {
        title: brandConfig.companyName,
        index: 0,
        keepAlive: true,
        titleBar: {
          show: false,
          title: brandConfig.companyName,
          menu: false
        }
      },
      component: Index
    },

    {
      path: "/my-account",
      name: "my-account",
      meta: {
        title: "我的账户",
        titleBar: {
          show: true,
          title: "我的账户",
          menu: false
        }
      },
      component: myAccount
    },
    {
      path: "/account-detail",
      name: "account-detail",
      meta: {
        title: "账户明细",
        titleBar: {
          show: true,
          title: "账户明细",
          menu: true
        }
      },
      component: accountDetail
    },
    {
      path: "/insurance-explain",
      name: "insuranceExplain",
      meta: {
        title: "意外险说明"
      },
      component: InsuranceExplain
    },
    {
      path: "/health-insurance",
      name: "HealthInsurance",
      meta: {
        title: "意外险说明"
      },
      component: HealthInsurance
    },
    // {
    //   path: '/oldIndex',
    //   name: 'old-index',
    //   meta: {
    //     title: brandConfig.companyName,
    //     index: 0,
    //     keepAlive: true
    //   },
    //   component: index1
    // },
    {
      path: "/dimi",
      name: "dimi",
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "实体卡-兑换",
          menu: true
        }
      },
      component: index
    },
    // packageListV2
    {
      path: "/package-list",
      name: "packageListV2",
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "套餐列表",
          menu: true
        },
        keepAlive: true,
        isBack: false
      },
      component: packageListV2
    },
    {
      path: "/package-58-list",
      component: package58List,
      name: "package-58-list",
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "套餐列表",
          menu: false,
          barCode:"58_city"
        },
        keepAlive: true,
        isBack: false
      },
    },
    {
      path: "/org-list",
      name: "orgListV2",
      meta: {
        title: "机构列表",
        titleBar: {
          show: false,
          title: "机构列表",
          menu: true
        },
        keepAlive: true,
        isBack: false
      },
      component: orgListV2
    },
    {
      path: "/search",
      name: "search",
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "搜索",
          menu: true
        },
        keepAlive: true,
        isBack: false
      },
      component: search
    },
    {
      path: "/success",
      name: "success",
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "兑换成功",
          menu: true
        }
      },
      component: success
    },
    {
      path: "/error",
      name: "error",
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "兑换异常",
          menu: true
        }
      },
      component: error
    },
    {
      path: "/fail",
      name: "fail",
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "兑换失败",
          menu: true
        }
      },
      component: fail
    },
    {
      path: "/mydmi",
      name: "mydmi",
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "我的D米",
          menu: true
        }
      },
      component: mydmi
    },
    {
      path: "/loading",
      name: "loading",
      meta: {
        title: "loading"
      },
      component: LoadingV1
    },
    {
      path: "/city-list",
      name: "city-list",
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "城市选择",
          menu: true
        }
      },
      component: cityList
    },
    {
      path: "/family-list",
      name: "family-list",
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "常用体检人",
          menu: true
        },
        keepAlive: false,
        isBack: false
      },
      component: familyList
    },
    {
      path: "/add-family/:id",
      name: "add-family",
      component: addFamily,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "常用体检人",
          menu: true
        }
      }
    },
    {
      path: "/add-yuyue",
      name: "add-yuyue",
      // component: addFamily,
      component: addYuYue,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "立即预约",
          menu: true
        }
      }
    },
    {
      path: "/package-detail/:id",
      name: "package-detail",
      component: packageDetail,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "",
          menu: true
        }
      }
    },
    {
      path: "/package-detail-v2/:id",
      name: "package-detail-v2",
      component: packageDetailV2,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "",
          menu: true
        }
      }
    },
    {
      path: "/pocket-induction",
      name: "pocket-induction",
      component: pocketInduction,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: false,
          title: "",
          menu: false
        }
      }
    },
    {
      path: "/pocket-special-physical-examination",
      name: "pocket-special-physical-examination",
      component: pocketSpecialPhysicalExamination,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: false,
          title: "",
          menu: false
        }
      }
    },
    {
      path: "/org-detail/:id",
      name: "org-detail",
      component: orgHome,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "",
          menu: true
        }
      }
    },
    {
      path: "/package-org",
      name: "package-org",
      component: packageOrg,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "选择体检机构",
          menu: true
        },
        keepAlive: true
      }
    },
    {
      path: "/multi-package-list",
      name: "multi-package-list",
      component: multiPackageList,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "选择体检套餐",
          menu: true
        }
      }
    },
    {
      path: "/package-org-v2",
      name: "package-org-v2",
      component: packageOrgV2,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "选择体检机构",
          menu: true
        }
        // keepAlive: true,
        // isBack: false,
      }
    },
    {
      // 我的卡卷
      path: "/assets",
      name: "assets",
      component: Assets,
      redirect: "/assets/medical-card",
      children: [
        {
          // 体检卡
          path: "medical-card",
          name: "medical-card",
          component: MedicalCard,
          meta: {
            title: brandConfig.companyName,
            titleBar: {
              show: true,
              title: "我的卡包",
              menu: true
            }
          }
        },
        {
          // 优惠券
          path: "coupon",
          name: "coupon",
          component: Coupon,
          meta: {
            title: brandConfig.companyName,
            titleBar: {
              show: true,
              title: "我的卡券",
              menu: true
            }
          }
        },
        {
          // 预付卡购买
          path: "prepaid-card-detail/:id",
          name: "prepaid-card-detail",
          component: PrepaidCardDetail,
          meta: {
            title: brandConfig.companyName,
            titleBar: {
              show: true,
              title: "卡片详情",
              menu: true
            }
          }
        },
        {
          // 预付卡详情
          path: "card-transaction-detail/:id",
          name: "card-transaction-detail",
          component: CardTransactionDetail,
          meta: {
            title: brandConfig.companyName,
            titleBar: {
              show: true,
              title: "消费详情",
              menu: true
            }
          }
        },
        {
          // 消费章程
          path: "consumption-regulation",
          name: "consumption-regulation",
          component: ConsumptionRegulation,
          meta: {
            title: brandConfig.companyName,
            titleBar: {
              show: true,
              title: "消费章程"
            }
          }
        },
        {
          // 购卡协议
          path: "purchase-agreement",
          name: "purchase-agreement",
          component: PurchaseAgreement,
          meta: {
            title: brandConfig.companyName,
            titleBar: {
              show: true,
              title: "购卡协议"
            }
          }
        }
      ]
    },
    {
      path: "/evaluate",
      name: "evaluate",
      component: evaluate,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "撰写评价",
          menu: true
        }
      }
    },
    {
      path: "/apply",
      name: "apply",
      component: apply,
      meta: {
        title: "提交订单"
        // keepAlive: true,
      }
    },
    {
      path: "/apply-before",
      name: "apply-before",
      component: applyBefore,
      meta: {
        title: "提交订单"
        // keepAlive: true,
      }
    },
    {
      path: "/apply-addItem",
      name: "apply-addItem",
      component: applyAddItem,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "体检细项",
          menu: false
        }
      }
    },
    {
      path: "/medicalcard-apply/:id",
      name: "medicalcard-apply",
      component: medicalcardApply,
      meta: {
        title: "提交订单"
      }
    },
    // MedicalCardOrg
    {
      path: "/medicalcard-org",
      name: "medicalcard-org",
      component: MedicalCardOrg,
      meta: {
        title: "选择体检机构"
      }
    },
    {
      path: "/agreement",
      name: "agreement",
      component: agreement,
      meta: {
        title: "用户授权协议"
      }
    },
    {
      path: "/user-center",
      name: "user-center",
      component: UserCenter,
      meta: {
        title: "个人中心",
        titleBar: {
          show: false,
          title: "个人中心",
          menu: true
        }
      }
    },
    {
      path: "/mypoint",
      name: "mypoint",
      component: Mypoint,
      meta: {
        title: "积分明细",
        titleBar: {
          show: false,
          title: "积分明细",
          menu: true
        }
      }
    },
    {
      path: "/feedback-help",
      name: "feedback-help",
      component: FeedbackHelp,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "帮助与反馈",
          menu: true
        },
        keepAlive: true
      }
    },
    {
      path: "/feedback",
      name: "feedback",
      component: Feedback,
      meta: {
        keepAlive: true,
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "意见反馈",
          menu: true
        }
      }
    },
    {
      path: "/feedback-result",
      name: "feedbackResult",
      component: FeedbackResult,
      meta: {
        keepAlive: true,
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "意见反馈",
          menu: true
        }
      }
    },
    {
      path: "/assistant",
      name: "assistant",
      component: Assistant,
      meta: {
        keepAlive: false,
        title: "袋鼠助手"
      }
    },
    {
      path: "/problem",
      name: "problem",
      component: problem,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "帮助与反馈",
          menu: true
        }
      }
    },
    {
      path: "/report",
      name: "report",
      component: report,
      meta: {
        title: "体检报告",
        titleBar: {
          show: false,
          title: "体检报告",
          menu: true
        }
      }
    },
    {
      path: "/report/list",
      name: "reportList",
      component: reportList,
      meta: {
        title: "报告查询",
        titleBar: {
          show: true,
          title: "报告查询",
          menu: true
        }
      }
    },
    {
      path: "/report/upload",
      name: "upload",
      component: uploadReport,
      meta: {
        title: "体检报告",
        titleBar: {
          show: true,
          title: "上传体检报告",
          menu: true
        }
      }
    },
    {
      path: "/report/detail",
      name: "reportDetail",
      component: reportDetail,
      meta: {
        title: "报告详情",
        titleBar: {
          show: true,
          title: "报告详情",
          menu: true
        }
      }
    },
    {
      path: "/report/preview",
      name: "reportPreview",
      component: reportPreview,
      meta: {
        title: "体检报告",
        titleBar: {
          show: false,
          title: "体检报告",
          menu: false
        }
      }
    },
    // {
    //   path: '/report/viewurl/:id',
    //   name: 'viewurl',
    //   component: viewurl,
    //   meta: {
    //     title: brandConfig.companyName,
    //     titleBar: {
    //       show: true,
    //       title: '体检报告',
    //       menu: true
    //     }
    //   }
    // },
    // {
    //   path: '/orders',
    //   name: 'orders',
    //   component: orders,
    //   meta: {
    //     title: brandConfig.companyName,
    //     titleBar: {
    //       show: true,
    //       title: '订单列表',
    //       menu: true
    //     }
    //   }
    // },
    {
      path: "/order-list",
      name: "order-list-v2",
      component: OrderList,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "订单列表",
          menu: true
        }
      }
    },
    {
      path: "/orders",
      name: "orders",
      redirect: "/order-list"
    },
    {
      path: "/doctor-card-home",
      name: "doctor-card-home",
      component: DoctorCardHome,
      meta: {
        title: "袋鼠好医生",
        titleBar: {
          show: false,
          title: "袋鼠好医生",
          menu: false
        }
      }
    },
    {
      path: "/doctor-buy-history",
      name: "doctor-buy-history",
      component: DoctorBuyHistory,
      meta: {
        title: "袋鼠健康",
        titleBar: {
          show: true,
          title: "购买记录",
          menu: true
        }
      }
    },
    {
      path: "/doctor-card-give/:id",
      name: "doctor-card-give",
      component: DoctorCardGive,
      meta: {
        title: "袋鼠健康",
        titleBar: {
          show: true,
          title: "赠送健康卡",
          menu: true
        }
      }
    },
    {
      path: "/doctor-card-receive/:id",
      name: "doctor-card-receive",
      component: DoctorCardReceive,
      meta: {
        title: "健康管理平台",
        titleBar: {
          show: true,
          title: "领取健康卡",
          menu: true
        }
      }
    },
    {
      path: "/doctor-card-order-detail/:id",
      name: "doctor-card-order-detail",
      component: DoctorCardOrderDetail,
      meta: {
        title: "袋鼠健康",
        titleBar: {
          show: true,
          title: "订单详情",
          menu: true
        }
      }
    },
    {
      path: "/doctor-card-logistics/:order_id",
      name: "doctor-card-logistics",
      component: DoctorCardLogistics,
      meta: {
        title: "袋鼠好医生",
        titleBar: {
          show: true,
          title: "查看物流",
          menu: true
        }
      }
    },
    {
      path: "/doctor-card-list",
      name: "doctor-card-list",
      component: DoctorCardList,
      meta: {
        title: "袋鼠好医生",
        titleBar: {
          show: true,
          title: "健康档案",
          menu: true
        }
      }
    },
    {
      path: "/doctor-card-apply/:id",
      name: "doctor-card-apply",
      component: DoctorCardApply,
      meta: {
        title: "袋鼠好医生",
        titleBar: {
          show: true,
          title: "提交订单",
          menu: true
        }
      }
    },
    {
      path: "/doctor-card-exchange",
      name: "doctor-card-exchange",
      component: DoctorCardExchange,
      meta: {
        title: "健康管理平台",
        titleBar: {
          show: true,
          title: "卡密激活/赠送",
          menu: true
        }
      }
    },
    {
      path: "/doctor-card-package/:id",
      name: "doctor-card-package",
      component: DoctorCardPackage,
      meta: {
        title: "袋鼠好医生",
        titleBar: {
          show: true,
          title: "袋鼠好医生",
          menu: true
        }
      }
    },
    {
      path: "/doctor-card-repurchase/:id",
      name: "doctor-card-repurchase",
      component: DoctorCardRepurchase,
      meta: {
        title: "袋鼠好医生",
        titleBar: {
          show: true,
          title: "选购医生卡",
          menu: true
        }
      }
    },
    {
      path: "/doctor-card-member",
      name: "doctor-card-member",
      redirect: "/doctor-card-home"
    },
    {
      path: "/order-detail",
      name: "order-detail-v2",
      component: OrderDetail,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "订单详情",
          menu: true
        }
      }
    },
    {
      path: "/health-service-index",
      name: "health-service-index",
      component: healthServiceIndex,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "健康管理服务",
          menu: false
        }
      }
    },
    {
      path: "/health-service-package/:id",
      name: "health-service-package",
      component: healthServicePackage,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "健康管理服务",
          menu: false
        }
      }
    },
    {
      path: "/health-service-apply/:id",
      name: "health-service-apply",
      component: healthServiceApply,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "提交订单",
          menu: true
        }
      }
    },
    {
      path: "/health-service-orderlist",
      name: "health-service-orderlist",
      component: healthServiceOrderlist,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "健康包订单",
          menu: false
        }
      }
    },
    {
      path: "/health-service-orderdetail/:order_id",
      name: "health-service-orderdetail",
      component: healthServiceOrderdetail,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "订单详情",
          menu: true
        }
      }
    },
    {
      path: "/health-service-home",
      name: "health-service-home",
      component: healthServiceHome,
      meta: {
        title: "健康管理服务",
        titleBar: {
          show: false,
          title: "健康管理服务",
          menu: true
        }
      }
    },
    {
      path: "/health-service-cmbagree",
      name: "health-service-cmbagree",
      component: healthServiceCmbagree,
      meta: {
        title: "健康管理服务",
        titleBar: {
          show: true,
          title: "招商信诺服务告知及隐私保护政策",
          menu: true
        }
      }
    },
    {
      path: "/health-service-dsagree",
      name: "health-service-dsagree",
      component: healthServiceDsagree,
      meta: {
        title: "健康管理服务",
        titleBar: {
          show: true,
          title: "袋鼠用户协议",
          menu: true
        }
      }
    },
    {
      path: "/health-service-dspolicy",
      name: "health-service-dspolicy",
      component: healthServiceDspolicy,
      meta: {
        title: "健康管理服务",
        titleBar: {
          show: true,
          title: "袋鼠健康隐私保护政策",
          menu: true
        }
      }
    },
    // cardOrderDetail
    {
      path: "/card-order-detail/:order_id",
      name: "cardOrderDetail",
      component: cardOrderDetail,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "订单详情",
          menu: true
        }
      }
    },
    // {
    //   path: '/invoice-add',
    //   name: 'invoice-add',
    //   component: invoiceAdd,
    //   meta: {
    //     title: brandConfig.companyName,
    //     titleBar: {
    //       show: true,
    //       title: '填写发票信息',
    //       menu: true
    //     }
    //   }
    // },
    {
      path: "/register",
      name: "register",
      component: register,
      meta: {
        title: "",
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: "/register-suc",
      name: "register-suc",
      component: registerSuc,
      meta: {
        title: "登录成功"
      }
    },
    {
      path: "/provision",
      name: "provision",
      component: provision,
      meta: {
        title: "用户隐私保密协议"
      }
    },
    {
      path: "/provision-agree",
      name: "provision-agree",
      component: provisionAgree,
      meta: {
        title: "用户协议"
      }
    },
    {
      path: "/provision-privacy",
      name: "provision-privacy",
      component: provisionPrivacy,
      meta: {
        title: "隐私保护政策"
      }
    },
    {
      path: "/pay-after",
      name: "pay-after",
      component: payAfter,
      meta: {
        title: ""
      }
    },
    {
      path: "/pay-success",
      name: "pay-success",
      component: paySuccess,
      meta: {
        title: ""
      }
    },
    {
      path: "/pay-card-success",
      name: "pay-card-success",
      component: payCardSuccess,
      meta: {
        title: ""
      }
    },
    {
      path: "/pay-fail",
      name: "pay-fail",
      component: payFail,
      meta: {
        title: ""
      }
    },
    // bianla packageListBl
    // {
    //   path: '/package-list-bl',
    //   name: 'package-list-bl',
    //   component: packageListBl,
    //   meta: {
    //     title: brandConfig.companyName,
    //     index: 1
    //   }
    // },
    // {
    //   path: '/package-detail-bl',
    //   name: 'package-detail-bl',
    //   component: packageDetailBl,
    //   meta: {
    //     title: '套餐详情',
    //     index: 2
    //   }
    // },
    // 电子预付卡
    {
      path: "/card-mall",
      name: "card-mall",
      component: cardMall,
      meta: {
        index: 1,
        keepAlive: true,
        isBack: false,
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "袋鼠商城",
          menu: true
        }
      }
    },
    // 体检卡新版
    {
      path: "/medicalcard-list",
      name: "medicalcard-list",
      component: medicalcardList,
      meta: {
        index: 1,
        keepAlive: true,
        isBack: false,
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "袋鼠商城",
          menu: true
        }
      }
    },
    {
      path: "/medicalcard-detail/:id",
      name: "medicalcard-detail",
      component: medicalCardDetail,
      meta: {
        index: 2,
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "",
          menu: true
        }
      }
    },
    {
      path: "/medical-card-give/:id",
      name: "medical-card-give",
      component: medicalCardGive,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "",
          menu: true
        }
      }
    },
    {
      path: "/login-card",
      name: "login-card",
      component: loginCard,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "验证卡密",
          menu: true
        }
      }
    },

    {
      path: "/exchange-result",
      name: "exchange-result",
      component: exchangeResult,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "验证卡密",
          menu: true
        }
      }
    },
    {
      path: "/book-suc",
      name: "book-suc",
      component: bookSuc,
      meta: {
        title: "预约成功"
      }
    },
    {
      path: "/order-card",
      name: "order-card",
      component: orderCard,
      meta: {
        title: "提交订单"
      }
    },

    {
      path: "/org-detail-bl/:id",
      name: "org-detail-bl",
      component: orgDetailBl,
      meta: {
        title: "体检服务"
      }
    },

    {
      path: "/refund",
      name: "refund",
      component: refund,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "申请退款",
          menu: true
        }
      }
    },

    {
      path: "/refund-detail",
      name: "refund-detail",
      component: refundDetail,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "申请退款",
          menu: true
        }
      }
    },

    {
      path: "/refund-explain",
      name: "refund-explain",
      component: refundExplain,
      meta: {
        title: "退款说明"
      }
    },
    {
      path: "/addition",
      name: "addition",
      component: addition,
      meta: {
        title: "体检加项"
      }
    },
    // 通用活动commonActivity
    {
      path: "/common-activity/:id",
      name: "commonActivity",
      component: CommonActivity,
      meta: {
        title: "袋鼠健康",
        titleBar: {
          show: true,
          title: "袋鼠健康"
        }
      }
    },
    // 8月秒杀活动
    {
      path: "/activity/seckill",
      name: "seckill",
      component: SeckillApp,
      redirect: {
        name: "rush-to-buy"
      },
      children: [
        {
          path: "/activity/seckill/rush-to-buy",
          name: "rush-to-buy",
          component: SeckillRushToBuy,
          redirect: {
            name: "seckill-list-1"
          },
          children: [
            {
              path: "/activity/seckill/rush-to-buy/1",
              name: "seckill-list-1",
              component: SeckillList,
              meta: {
                title: "健康狂欢 秒杀大礼",
                key: 1
              }
            },
            {
              path: "/activity/seckill/rush-to-buy/2",
              name: "seckill-list-2",
              component: SeckillList,
              meta: {
                title: "健康狂欢 秒杀大礼",
                key: 2
              }
            },
            {
              path: "/activity/seckill/rush-to-buy/3",
              name: "seckill-list-3",
              component: SeckillList,
              meta: {
                title: "健康狂欢 秒杀大礼",
                key: 3
              }
            },
            {
              path: "/activity/seckill/rush-to-buy/4",
              name: "seckill-list-4",
              component: SeckillList,
              meta: {
                title: "健康狂欢 秒杀大礼",
                key: 4
              }
            }
          ]
        },
        {
          path: "/activity/seckill/result",
          name: "seckill-result",
          component: SeckillResult,
          meta: {
            title: "健康狂欢 秒杀大礼"
          }
        }
      ]
    },
    // 荔湾医院活动页面
    {
      path: "/activity/liwan",
      name: "liwan",
      component: liwan,
      meta: {
        title: "关爱身体 共享健康"
      }
    },
    {
      path: "/giftbag880",
      name: "giftbag880",
      component: Giftbag880,
      meta: {
        title: "体检权益大礼包"
      }
    },

    // 建行领券活动页面
    {
      path: "/activity/ccb",
      name: "ccb",
      component: ccb,
      meta: {
        title: "关爱身体 共享健康"
      }
    },
    {
      path: "/activity/liantong",
      name: "liantong",
      component: liantong,
      meta: {
        title: "关爱身体 共享健康"
      }
    },
    // 中秋节领劵活动页面
    {
      path: "/activity/coupon1",
      name: "coupon1",
      component: coupon1,
      meta: {
        title: "中秋特惠"
      }
    },
    // 中秋节领劵活动页面
    {
      path: "/activity/coupon2",
      name: "coupon2",
      component: coupon2,
      meta: {
        title: "中秋国庆双节特惠"
      }
    },
    // 重阳节活动
    {
      path: "/activity/double9",
      name: "double9",
      component: double9,
      meta: {
        title: "九九重阳"
      }
    },
    // 施予受活动
    {
      path: "/shiyushou",
      name: "shiyushou",
      component: ShiYuShou,
      meta: {
        title: "器官捐献志愿者优享计划专栏"
      }
    },
    // 施予受活动
    {
      path: "/shiyushou-extension",
      name: "shiyushou-extension",
      component: ShiYuShouExtension,
      meta: {
        title: "器官捐献志愿者优享计划专栏"
      }
    },

    // 双十一活动
    {
      path: "/activity/double-eleven",
      name: "doubleEleven",
      component: doubleEleven,
      meta: {
        title: "双十一福利盛惠开启！"
      }
    },
    {
      path: "/activity/double-seventh-2019",
      name: "doubleSeventh2019",
      component: doubleSeventh2019,
      meta: {
        title: "七夕，全场特享优惠"
      }
    },

    // 建行折扣活动
    {
      path: "/ccbDiscount",
      name: "ccbDiscount",
      component: ccbDiscount,
      alias: "/activity/ccbDiscount",
      meta: {
        title: "建行用户专享"
      }
    },
    // 建行折扣活动
    {
      path: "/activity/shuidichou",
      name: "shuidichou",
      component: ShuiDiChou,
      meta: {
        title: "点滴幸福，从健康体检开始"
      }
    },
    {
      path: "/activity/purcotton",
      name: "purcotton",
      component: purcotton,
      meta: {
        title: "全棉时代"
      }
    },
    // 问卷调查
    {
      path: "/questionnaire",
      component: Questionnaire,
      meta: {
        title: "健康定制"
      },
      redirect: {
        name: "questionnaireHome"
      },
      children: [
        {
          path: "/questionnaire/home",
          component: QuestionnaireHome,
          name: "questionnaireHome",
          meta: {
            current: "home",
            title: "健康定制",
            titleBar: {
              show: true,
              title: "健康定制",
              menu: false
            }
          }
        },
        {
          path: "/questionnaire/result",
          component: Result,
          meta: {
            title: "评估报告",
            titleBar: {
              show: true,
              title: "评估报告",
              menu: false
            }
          }
        },
        {
          path: "/questionnaire/answer",
          component: Answer,
          children: [
            {
              path: "disease",
              component: Problem1,
              meta: {
                order: 1,
                current: "disease",
                prev: "",
                next: "smoke",
                title: "健康定制",
                titleBar: {
                  show: true,
                  title: "健康定制",
                  menu: false
                }
              }
            },
            {
              path: "smoke",
              component: Problem2,
              meta: {
                order: 2,
                current: "smoke",
                prev: "disease",
                next: "drink",
                title: "健康定制",
                titleBar: {
                  show: true,
                  title: "健康定制",
                  menu: false
                }
              }
            },
            {
              path: "drink",
              component: Problem3,
              meta: {
                order: 3,
                current: "drink",
                prev: "smoke",
                next: "stayuplate",
                title: "健康定制",
                titleBar: {
                  show: true,
                  title: "健康定制",
                  menu: false
                }
              }
            },
            {
              path: "stayuplate",
              component: Problem4,
              meta: {
                order: 4,
                current: "stayuplate",
                prev: "drink",
                next: "taste",
                title: "健康定制",
                titleBar: {
                  show: true,
                  title: "健康定制",
                  menu: false
                }
              }
            },
            {
              path: "taste",
              component: Problem5,
              meta: {
                order: 5,
                current: "taste",
                prev: "stayuplate",
                next: "sport",
                title: "健康定制",
                titleBar: {
                  show: true,
                  title: "健康定制",
                  menu: false
                }
              }
            },
            {
              path: "sport",
              component: Problem6,
              meta: {
                order: 6,
                current: "sport",
                prev: "taste",
                next: "nausea",
                title: "健康定制",
                titleBar: {
                  show: true,
                  title: "健康定制",
                  menu: false
                }
              }
            },
            {
              path: "nausea",
              component: Problem7,
              meta: {
                order: 7,
                current: "nausea",
                prev: "sport",
                next: "halo",
                title: "健康定制",
                titleBar: {
                  show: true,
                  title: "健康定制",
                  menu: false
                }
              }
            },
            {
              path: "halo",
              component: Problem8,
              meta: {
                order: 8,
                current: "halo",
                prev: "nausea",
                next: "chest",
                title: "健康定制",
                titleBar: {
                  show: true,
                  title: "健康定制",
                  menu: false
                }
              }
            },
            {
              path: "chest",
              component: Problem9,
              meta: {
                order: 9,
                current: "chest",
                prev: "halo",
                next: "",
                title: "健康定制",
                titleBar: {
                  show: true,
                  title: "健康定制",
                  menu: false
                }
              }
            }
          ]
        }
      ]
    },
    {
      path: "/pay-details",
      name: "pay-details",
      component: payDetails,
      meta: {
        title: "订单详情"
      }
    },
    {
      path: "/my-policy",
      name: "my-policy",
      component: myPolicy,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "我的保单",
          menu: true
        }
      }
    },
    {
      path: "/history-policy",
      name: "history-policy",
      component: historyPolicy,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "历史保单",
          menu: true
        }
      }
    },
    {
      path: "/after-sale",
      name: "after-sale",
      component: AfterSale,
      meta: {
        title: "健康管理平台",
        titleBar: {
          show: true,
          title: "申请售后",
          menu: true
        }
      }
    },
    {
      path: "/policy-detail/:id",
      name: "policy-detail",
      component: policyDetail,
      meta: {
        title: "保单详情"
      }
    },
    {
      path: "/excellent-enjoyment",
      name: "excellent-enjoyment",
      component: ExcellentEnjoyment,
      meta: {
        title: "优享活动"
      }
    },
    // JoininSuc
    {
      path: "/joinin-suc",
      name: "joinin-suc",
      component: JoininSuc,
      meta: {
        title: "优享活动"
      }
    },
    // EntryWelfare
    {
      path: "/entry-welfare",
      name: "entry-welfare",
      component: EntryWelfare,
      meta: {
        title: "入职体检"
      }
    },
    // TaiWelfare
    {
      path: "/tai-welfare",
      name: "tai-welfare",
      component: TaiWelfare,
      redirect: "/third-party",
      meta: {
        title: "泰福利",
        keepAlive: true,
        isBack: false
      }
    },
    // ThirdPartyIndex
    {
      path: "/third-party",
      name: "third-party",
      component: ThirdPartyIndex,
      meta: {
        title: "首页",
        keepAlive: true,
        isBack: false
      }
    },
    // ThirdPartyIndexDemo
    {
      path: "/third-party-demo",
      name: "third-party-demo",
      component: ThirdPartyIndexDemo,
      meta: {
        title: "首页",
        keepAlive: true,
        isBack: false
      }
    },
    // Reload
    {
      path: "/reload",
      name: "reload",
      component: Reload,
      meta: {
        title: "体检服务"
      }
    },
    {
      path: "/nanyida",
      name: "nanyida",
      component: Nanyida,
      meta: {
        title: "南医大"
      }
    },
    {
      path: "/cooperation",
      name: "cooperation",
      component: Cooperation,
      meta: {
        keepAlive: true,
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "企业服务",
          menu: true
        }
      }
    },
    {
      path: "/software-consulting",
      name: "software-consulting",
      component: SoftwareConsulting,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "体软咨询",
          menu: true
        },
        keepAlive: true
      }
    },
    {
      path: "/business-cooperation",
      name: "business-cooperation",
      component: BusinessCooperation,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "商务合作",
          menu: true
        },
        keepAlive: true
      }
    },
    {
      path: "/business-needs",
      name: "business-needs",
      component: BusinessNeeds,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "企业需求",
          menu: false
        },
        keepAlive: true
      }
    },
    {
      path: "/new_business-needs",
      name: "new_business-needs",
      component: NewBusinessNeeds,
      meta: {
        title: "开通申请",
        titleBar: {
          show: false,
          title: "开通申请",
          menu: true
        },
        keepAlive: true
      }
    },
    {
      path: "/agent-joining",
      name: "agent-joining",
      component: AgentJoining,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "招商加盟",
          menu: true
        },
        keepAlive: true
      }
    },
    {
      path: "/comparison",
      name: "comparison",
      component: Comparison,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "套餐对比",
          menu: true
        }
      }
    },
    {
      path: "/comparison-select",
      name: "ComparisonSelect",
      component: ComparisonSelect,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "套餐对比",
          menu: true
        }
      }
    },
    {
      path: "/news-detail",
      name: "news-detail",
      component: NewsDetail,
      meta: {
        title: "健康资讯",
        titleBar: {
          show: true,
          title: "健康资讯",
          menu: true
        },
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: "/submit-success",
      name: "submit-success",
      component: SubmitSuccess,
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "",
          menu: false
        },
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: "/news-list",
      name: "news-list",
      component: NewsList,
      redirect: {
        path: "/news-list/1"
      },
      children: [
        {
          path: "1",
          component: NewsList1,
          meta: {
            index: 0,
            type: 1,
            keepAlive: true,
            title: brandConfig.companyName,
            titleBar: {
              show: true,
              title: "健康资讯",
              menu: true
            }
          }
        },
        {
          path: "2",
          component: NewsList2,
          meta: {
            index: 1,
            type: 2,
            keepAlive: true,
            title: brandConfig.companyName,
            titleBar: {
              show: true,
              title: "健康资讯",
              menu: true
            }
          }
        },
        {
          path: "3",
          component: NewsList3,
          meta: {
            index: 2,
            type: 3,
            keepAlive: true,
            title: brandConfig.companyName,
            titleBar: {
              show: true,
              title: "健康资讯",
              menu: true
            }
          }
        },
        {
          path: "4",
          component: NewsList4,
          meta: {
            index: 3,
            type: 4,
            keepAlive: true,
            title: brandConfig.companyName,
            titleBar: {
              show: true,
              title: "健康资讯",
              menu: true
            }
          }
        },
        {
          path: "5",
          component: NewsList5,
          meta: {
            index: 4,
            type: 5,
            keepAlive: true,
            title: brandConfig.companyName,
            titleBar: {
              show: true,
              title: "健康资讯",
              menu: true
            }
          }
        },
        {
          path: "6",
          component: NewsList6,
          meta: {
            index: 1,
            type: 6,
            keepAlive: true,
            title: brandConfig.companyName,
            titleBar: {
              show: true,
              title: "疫情科普",
              menu: true
            }
          }
        }
      ]
    },
    {
      path: "/collection",
      name: "collection",
      component: Collection,
      redirect: {
        name: "CollectionPackage"
      },
      children: [
        {
          path: "org",
          component: CollectionOrg,
          name: "CollectionOrg",
          meta: {
            title: brandConfig.companyName,
            titleBar: {
              show: true,
              title: "我的收藏",
              menu: true
            }
          }
        },
        {
          path: "package",
          component: CollectionPackage,
          name: "CollectionPackage",
          meta: {
            title: brandConfig.companyName,
            titleBar: {
              show: true,
              title: "我的收藏",
              menu: true
            }
          }
        },
        {
          path: "article",
          component: CollectionArticle,
          name: "CollectionArticle",
          meta: {
            title: brandConfig.companyName,
            titleBar: {
              show: true,
              title: "我的收藏",
              menu: true
            }
          }
        }
      ]
    },
    {
      path: "/reservation",
      component: ReservationIndex,
      name: "ReservationIndex",
      meta: {
        title: "体检指引"
      }
    },
    {
      path: "/doctor-card-two",
      component: doctorCard2,
      name: "doctor-card-two",
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "袋鼠好医生",
          menu: true
        }
      }
    },
    {
      path: "/doctor-card-center",
      component: doctorCardCenter,
      name: "doctor-card-center",
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "个人中心",
          menu: true
        }
      }
    },
    {
      path: "/doctor-card-coupon",
      component: doctorCardCoupon,
      name: "doctor-card-coupon",
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "我的优惠券",
          menu: true
        }
        // isBack: false
      }
    },
    {
      path: "/doctor-card-package2/:id/:cardId",
      component: doctorCardPackage2,
      name: "doctor-card-package2",
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "袋鼠好医生",
          menu: true
        }
      }
    },
    {
      path: "/doctor-card-packageDetail/:id/:priceId",
      component: doctorCardPackageDetail,
      name: "doctor-card-packageDetail",
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "套餐详情",
          menu: true
        }
      }
    },
    {
      path: "/insuranceTest",
      component: insuranceTest,
      name: "insurance-test",
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "健康保险",
          menu: true
        }
      }
    },
    {
      path: "/group-buy-detail",
      component: groupBuyDetail,
      name: "group-buy-detail",
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "拼团详情",
          menu: true
        }
      }
    },
    {
      path: "/package-org-list",
      component: packageOrgList,
      name: "package-org-list",
      meta: {
        title: brandConfig.companyName,
        // titleBar: {
        //   show: true,
        //   title: '体检预约',
        //   menu: true
        // },
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: "/package-org-list-specialty",
      component: packageOrgListSpecialty,
      name: "package-org-list",
      meta: {
        title: brandConfig.companyName,
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: "/set-up",
      component: setUp,
      name: "set-up",
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "设置",
          menu: true
        }
      }
    },
    {
      path: "/set-up-agreement",
      component: setUpAgreement,
      name: "set-up-agreement",
      meta: {
        title: brandConfig.companyName,
        titleBar: {
          show: true,
          title: "协议及政策",
          menu: true
        }
      }
    }
  ]
  // scrollBehavior(to, from, savedPosition) {
  // if (to.name === 'doctor-list') {
  // return savedPosition
  // }
  // }order-detail
});
// 在路由完成初始导航时调用换肤
router.onReady(() => {
  // 储存channel
  let channel = sessionStorage.getItem("channel");
  if (!channel) {
    channel = getUrlSpecifiedParam("channel");
    channel && sessionStorage.setItem("channel", channel);
  }

  channel && setCookie("channel-code", channel);
  channel && setCookie("channel", channel);
  skinning();
  seoVisitLog();
  getUrlSpecifiedParam("token") &&
    setCookie("dmiddle_sso_token", getUrlSpecifiedParam("token")); // 保存token
});

function isFamilyDoctorFun(to, from) {
  // console.log('to:', to, 'from:', from)
  // 判断是否袋鼠好医生
  if (
    getUrlSpecifiedParam("is_family_doctor") == 1 ||
    (to.name && to.name.indexOf("doctor-card-") !== -1)
  ) {
    sessionStorage.setItem("is_family_doctor", 1);
  }
  // 袋鼠好医生的话隐藏title menu
  if (sessionStorage.getItem("is_family_doctor") == 1) {
    if (to.name === "package-org") {
      to.meta.titleBar.title = "选择体检套餐";
    }
    isFamilyDoctor = true;
  }
  // 进来个检的订单详情页就把 好医生的标记清掉, 因为以前订单是没有好医生卡的,现在有了. 不清掉的菜单返回会有问题
  // if (to.name === 'order-list-v2' || from.name === 'order-list-v2') {
  //   sessionStorage.removeItem('is_family_doctor')
  //   isFamilyDoctor = false
  // }
  if (
    to.name === "doctor-card-give" &&
    (from.name === "doctor-card-order-detail" || from.name === "index")
  ) {
    sessionStorage.removeItem("is_family_doctor");
    isFamilyDoctor = false;
  }
}

// 动态改变页面title
router.beforeEach((to, from, next) => {
  if (to.query.isOrg == 1 && !sessionStorage.getItem("isOrg")) {
    sessionStorage.setItem("isOrg", 1);
  }

  // 添加百度统计
  if (to.path && window._hmt) {
    window._hmt.push([
      "_trackPageview",
      window.location.href.split(window.location.host)[1]
    ]);
  }

  // 是否袋鼠好医生
  isFamilyDoctorFun(to, from);

  // wxTitleHack()
  // 页面切换时，关闭当前页面toast
  Vue.$toastObj && Vue.$toastObj.close();

  $(window).unbind("scroll");
  // 清除提交订单页面的缓存
  var applyKeepAlive = [
    "addition",
    "apply-before",
    "apply-addItem",
    "agreement",
    "apply",
    "insuranceExplain"
  ];

  if (applyKeepAlive.indexOf(to.name) === -1) {
    if (sessionStorage.getItem("applyData")) {
      sessionStorage.removeItem("applyData");
    }
    if (sessionStorage.getItem("orderTime")) {
      sessionStorage.removeItem("orderTime");
    }
  }

  // console.log(to.name === "doctor-card-home", sessionStorage.getItem("card") === '2')

  // 判断是否是春雨医院
  // if (to.name === "user-center" && sessionStorage.getItem("card") === '2') {
  //   router.replace('/doctorCardCenter')
  //   return
  // }

  // if (to.name === "doctor-card-home" && sessionStorage.getItem("card") === '2') {
  //   router.replace('/doctorCard2')
  //   return
  // }

  // 需要授权的页面 在config/auth.js定义
  if (authNeedPages.indexOf(to.name) !== -1) {
    // 螺杆菌1元活动先展示页面，不授权
    // if (to.path !== "/common-activity/209") {
    if (!to.path.includes("/common-activity")) {
      authNeed(to, next);
      return;
    }
  }

  next();
});

function changeTitle(to, from) {
  // hack在微信等webview中无法修改document.title的情况
  // 利用iframe的onload事件刷新页面

  if (to.name === "exchange-result") {
    switch (to.query.had) {
      case "2":
        document.title = "非法链接";
        break;
      default:
        document.title = isWechatSubscription
          ? to.meta.titleBar.title
          : to.meta.title;
        break;
    }
  } else {
    let title =
      to.meta.title == brandConfig.companyName
        ? !to.meta.titleBar ||
          (to.meta.titleBar &&
            to.meta.titleBar.title == brandConfig.companyName)
          ? ""
          : to.meta.titleBar.title
        : to.meta.title;
    document.title = isWechatSubscription
      ? title || ""
      : store.state.comefrom
      ? store.state.comefrom.windowTitle
      : to.meta.title;
  }
}

function wxTitleHack() {
  // hack在微信等webview中无法修改document.title的情况
  var $body = $("body");
  var $iframe = $('<iframe src="/favicon.ico"></iframe>');
  $iframe.css("visibility", "hidden");
  $iframe
    .on("load", function() {
      setTimeout(function() {
        $iframe.off("load").remove();
      }, 0);
    })
    .appendTo($body);
}

router.afterEach((to, from) => {
  Dialog.close();

  changeTitle(to, from); // 网页title修改

  let noSharePage = ["doctor-card-give", "news-detail", "group-buy-detail"]; // 禁用通用分享的页面
  // 访问渠道为微信浏览器或者不是小程序时，调用微信分享
  setCookie("_current_url", appPath + "h5#" + to.fullPath);
  setTimeout(() => {
    if (
      BROSWER_TYPE === "1" &&
      !ISWEBVIEW &&
      noSharePage.indexOf(to.name) === -1 &&
      !(from.name === "" && isWechatSubscription) // 如果是代运营公众号且是首次进入的时候不需要调用分享，因为App.vue已经调用过了
    ) {
      DistinguishWechatShare(to, from);
    }
  }, 200);

  // 区分不同入口的微信分享内容
  function DistinguishWechatShare(to, from) {
    let params = brandConfig.shareParams;
    params.title = to.meta.title;

    let url = getLinktoAuthUrl(); // 分享会时把channel也带出去
    // 机构公众号入口
    if (isWechatSubscription && sessionStorage.getItem("channelOrgInfo")) {
      let { name, img } = JSON.parse(sessionStorage.getItem("channelOrgInfo"));
      params = {
        title: name,
        desc: "体检预约",
        link: url,
        imgUrl: img,
        implementRequest: true // 是否重新获取设置分享配置
      };
    }

    // 是否家庭医生用户
    if (isFamilyDoctor || store.state.comefrom) {
      params = {
        title: "健康管理平台",
        desc:
          "一个有温度的健康管理服务平台。提供全国公立医院及体检机构的个人/团体体检预约，在线健康咨询、体检报告查询；体检报告解读；及其他企业健康福利预约服务。",
        link: window.healthHome,
        imgUrl:
          "http://public-10006067.file.myqcloud.com/imgpath/WechatIMG395.png",
        implementRequest: true // 是否重新获取设置分享配置
      };
    }

    wechatShare(params);
  }
  // Winscroll();
  // $(window).scroll(() => {
  //   setTimeout(function () {
  //     Winscroll();
  //   }, 300)
  // });

  setTimeout(function() {
    if (typeof MtaH5 !== "undefined") {
      MtaH5 && MtaH5.pgv && MtaH5.pgv(); // 移动分析
    }
  }, 1500);
});

function Winscroll() {
  // 页面滚动事件
  var totalheight =
    parseFloat($(window).height()) + parseFloat($(window).scrollTop());
  var getScrollTop = GetScrollTop();
  var isBottom = $(document).height() <= totalheight;
  if (isBottom || getScrollTop < 150) {
    // 页面到达底部或顶部
    $(".webview-top").addClass("webview-animateHide");
    // 页面到达底部
    if (isBottom && getScrollTop > 0) {
      // 一屏没铺满的情况
      $(".miniapp-history").addClass("webview-animateHide");
    }
  } else {
    $(".webview-top").removeClass("webview-animateHide");
    $(".miniapp-history").removeClass("webview-animateHide");
  }
}

function GetScrollTop() {
  var scrollTop = 0;
  if (document.documentElement && document.documentElement.scrollTop) {
    scrollTop = document.documentElement.scrollTop;
  } else if (document.body) {
    scrollTop = document.body.scrollTop;
  }
  return scrollTop;
}

export default router;
